<template>
    <a
        :href="backURL"
        aria-label="Ga naar de homepage"
        class="header__site-logo"
        target="_blank"
    >
        <svg
            class="logo"
            version="1.1"
            viewBox="0 0 70.9 70.9"
            xmlns="http://www.w3.org/2000/svg"
        >
            <radialGradient
                id="SVGID_1_"
                cx="-51.052"
                cy="21.353"
                r="229.89"
                gradientTransform="matrix(.1533 0 0 -.1533 43.258 38.872)"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#2895D3" offset=".6661" />
                <stop stop-color="#2481BA" offset=".6784" />
                <stop stop-color="#22699B" offset=".6976" />
                <stop stop-color="#215684" offset=".7194" />
                <stop stop-color="#204873" offset=".7441" />
                <stop stop-color="#1E3F68" offset=".7728" />
                <stop stop-color="#1D3860" offset=".8084" />
                <stop stop-color="#1C345B" offset=".8583" />
                <stop stop-color="#1C345A" offset=".9968" />
            </radialGradient>
            <circle
                class="st0"
                cx="35.4"
                cy="35.6"
                r="35.2"
                fill="url(#SVGID_1_)"
            />
            <circle class="st1" cx="35.4" cy="35.6" r="14.1" fill="#f3e8d0" />
        </svg>
    </a>
</template>
<script>
export default {
    name: "HomeButton",
    props: {
        backURL: String,
    },
};
</script>
<style scoped>
.header__site-logo {
    margin-right: auto;
}

.header__site-logo .logo {
    overflow: visible;
    height: 3.2rem;
    transition: all 350ms ease-in-out;
    transform-origin: left;
}

@media (max-width: 1200px) {
    .header__site-logo {
        margin-right: 0px;
    }
}

@media (min-width: 768px) {
    .header__site-logo .logo {
        height: 5rem;
    }
}
</style>
